export default __webpack_public_path__ + "static/media/DownloadSimple.d52ead43.svg";